import { isMotionValue } from '../../../../../motion-dom/dist/es/value/utils/is-motion-value.mjs';

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

export { isWillChangeMotionValue };
